<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#A7BA38" title="">
      <!-- <div>
        <br>
        <v-btn
          class="mx-2"
          dark
          small
          color="success"
          @click="
            $router.push({
              name: 'Home',
            })
          "
        >
          Menú
        </v-btn>
        <br>
        <br>
      </div> -->
      <notifications group="operator" />
      <v-dialog v-model="showInactiveModal" max-width="500">
          <v-card>
            <v-card-title class="text-h5 justify-center modal-info" style="color: white">
              Conversación Inactiva
              <v-spacer></v-spacer>
              <v-btn icon dark @click="handleNo">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text>
              <p>Esta conversación ha estado inactiva. ¿Desea finalizar la conversación?</p>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions class="justify-space-around">
              <v-btn color="blue darken-1" text @click="handleNo" small>
                No
              </v-btn>
              <v-btn color="red darken-1" text @click="handleYes" small>
                Sí
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      <v-row no-gutters style="max-height: 100vh; background-color: #F5F4F7; margin: 0px 0px 10px 20px;">

        <!-- Menú Lateral -->
        <v-col class="bg-light " v-if="showMenu" :class="{ 'col-2': $vuetify.breakpoint.smAndDown, 'col-md-2': $vuetify.breakpoint.mdAndUp }">
          
          <p style="font-size: 20px; padding: 20px 20px 0px 20px">Bandeja</p>
          <p style="font-size: 14px; padding-left: 20px">CONVERSACIONES</p>
          <p style="padding-left: 20px;">
            <i
              id="powerButton"
              class="mdi mdi-power mdi-36px"
              style="cursor: pointer; transition: transform 0.3s, box-shadow 0.3s, border 0.3s, background-color 0.3s; border: 1px solid #ccc; border-radius: 6px; display: inline-block; width: 36px; height: 36px; line-height: 36px; text-align: center;"
              :style="{ color: buttonColor, boxShadow: isButtonPressed ? '0 0 10px rgba(0, 0, 0, 0.5) inset' : '0 0 10px rgba(0, 0, 0, 0.1)', transform: isButtonPressed ? 'scale(0.95)' : 'scale(1)', backgroundColor: isButtonPressed ? '#f0f0f0' : (buttonColor === 'green' ? '#9effa9' : 'transparent') }"
              @click="operatorStatus"
              @mousedown="pressButton"
              @mouseup="releaseButton"
              @mouseleave="releaseButton"
            ></i>
          </p>
          <v-divider class="mb-6"></v-divider>

          <v-row align="center" style="padding-left: 20px; margin-right: 20px;">
            <v-list-item
              v-on:click="selectMenuItem(1)"
              class="d-flex align-center justify-space-between"
            >
              <v-list-item-title>
                Tu
              </v-list-item-title>
              <v-badge color="#DB1D4A" :content="countTu > 0 ? countTu : '0'"></v-badge>
            </v-list-item>

            <v-list-item 
              class="d-flex align-center justify-space-between" 
              v-on:click="selectMenuItem(2)"
            >
              <v-list-item-title>
                Asignado a otros
              </v-list-item-title>
              <v-badge color="#DB1D4A" :content="countOtros > 0 ? countOtros : '0'"></v-badge>
            </v-list-item>

            <v-list-item 
              class="d-flex align-center justify-space-between"
              v-on:click="selectMenuItem(3)"
            >
              <v-list-item-title>
                Todo 
              </v-list-item-title>
              <v-badge color="#DB1D4A" :content="countTodo > 0 ? countTodo : '0'"></v-badge>
            </v-list-item>

            <v-list-item 
              class="d-flex align-center justify-space-between" 
              v-on:click="selectMenuItem(5)"
            >
              <v-list-item-title>
                ChatGPT
              </v-list-item-title>
              <v-badge color="#DB1D4A" :content="countTodosRegistros > 0 ? countTodosRegistros : '0'"></v-badge>
            </v-list-item>
          </v-row>
          <div style="margin-top: 10%; " >
            <p style="font-size: 14px; padding-left: 20px;">COMPAÑEROS</p>

            <v-text-field
              v-model="textSearchContact"
              label="Buscar compañeros"
              @input="textSearchContact ? searchOperadores() : ''"
              style="padding-left: 7%; padding-right: 7%;"
            >
            </v-text-field>
            <!-- seccion compañeros -->
            <v-col style="max-height: 30vh; margin-top:5px; padding-left: 20px;" class="overflow-y-auto">
              <div v-for="(companero, index) in (textSearchContact ? operadorEncontrado : companeros)" :key="index" style="margin-top: 10%; margin-right: 15px;" 
                class="d-flex align-center justify-space-between" 
              > 
                <p style="margin-bottom: 0px; padding-right: 15px;"  @click="getChatsCompanero(companero.id)">{{ companero.nombre }}</p>
                <v-badge color="#DB1D4A" :content="companero.countChatsAsignados > 0 ? companero.countChatsAsignados : '0'"> 
                </v-badge>
              </div>
            </v-col>
          </div>
        </v-col>

        <!-- Panel de Chats -->
        <v-col v-if="showChatPanel" style="background-color: white;" :class="{ 'col-3': $vuetify.breakpoint.smAndDown, 'col-md-3': $vuetify.breakpoint.mdAndUp }">
          <p style="font-size: 20px; padding: 20px 0px 0px 20px;">

            Todo
          </p>
          
          <v-col class="overflow-y-auto" style="max-height: 67vh" cols="12">
            <v-row v-for="chat in getSelectedOptionChats()" :key="chat.chatGptId" @click="() => {
                  chatFocused = chat;
                  getSelectedChat(chat, chat.ultimo_mensaje_visto == 1 ? false : true);
              }">
                    <v-col class="d-flex align-center">
                        <!-- Foto de perfil -->
                        <v-list-item-avatar class="mr-2">
                            <v-img :src="chat.imagen" v-if="chat.imagen" style="cursor: pointer"></v-img>
                            <v-img v-else style="background-color: #8FC6DC; cursor: pointer">
                                <v-icon color="#fff">mdi-account</v-icon>
                            </v-img>
                        </v-list-item-avatar>
                        <v-col style="margin-top:10px; padding-left: 20px;">
                            <v-row class="d-flex align-left justify-space-between">
                                <div style="display: flex; align-items: center;">
                                  <span style="cursor: pointer; margin-right: 8px;" :style="!chat.ultimo_mensaje_visto && 'font-weight: bold;'">{{ chat.alumno }}</span>      
                                    <v-badge 
                                      v-if="isInactive(chat.horaUltimoMensaje, chat.fechaUltimoMensaje)" 
                                      color="orange" 
                                      overlap 
                                      style="margin-left: 10px; margin-top: -5px;">
                                        <span slot="badge">{{ 'Inactivo Hace más de 1 Hora' }}</span>
                                    </v-badge>
                                </div>
                                <div>
                                    <span style="font-size: 65%; margin-left: 20px;" class="text-right">{{ chat.horaUltimoMensaje }}</span>
                                </div>
                            </v-row>
                            <v-row>
                                <span style="font-size: 65%; margin-right: 20%; cursor: pointer;">{{ chat.ultimoMensaje }}</span>
                            </v-row>
                        </v-col>
                    </v-col>
            </v-row>


          </v-col>
        </v-col>

        <!-- Conversaciones-->
        <v-col :class="{ 'col-12': $vuetify.breakpoint.smAndDown, 'col-md-7': $vuetify.breakpoint.mdAndUp }">
          <v-row v-if="selectedChatData">
            <v-card-text>
                      <v-col class="d-flex align-center" style="margin-top: -10px; margin-bottom: -10px">
                        <!-- Foto de perfil -->
                <v-list-item-avatar class="mr-2">
                  <v-img :src="selectedChatData.imagen" v-if="selectedChatData.imagen"></v-img>
                  <v-img v-else style="background-color: #8FC6DC;">
                    <v-icon color="#fff">mdi-account</v-icon>
                  </v-img>
                </v-list-item-avatar>
                <div style="display: flex; flex-direction: column;">
                  <!-- Contenedor para el nombre del alumno y el botón "Interceder" -->
                  <div style="display: flex; align-items: center; margin-bottom: 5px;">
                    <!-- Información del alumno -->
                    <span class="mr-2" style="font-size: 130%;">{{ selectedChatData.alumno }}</span>

                    <!-- Botón "Interceder" -->
                    <v-btn 
                      v-if="selectedOption === 5" 
                      :style="{ 
                        backgroundColor: this.buttonColor2,
                        color: 'white',  // Color de texto blanco para mejor contraste
                        fontWeight: 'bold',  // Negrita para resaltar el texto
                        fontSize: '10px', 
                        padding: '4px 6px', 
                        minWidth: 'auto',
                        minHeight: 'auto',
                        lineHeight: 'normal',
                        marginLeft: '12px',  // Espaciado entre el nombre y el botón
                        transform: isButtonActive ? 'scale(0.95)' : 'scale(1)',
                        transition: 'transform 0.1s ease'
                      }" 
                      @click="toggleButton(selectedChat)"
                    >
                      Interceder
                    </v-btn>
                    

                  </div>

                  <!-- Enlace para ver información -->
                  <a :href="(debug ? 'http://localhost:8001/' : 'https://sistemaiea.com/') + 'alumnos.legajo.ver.php?editar_por_id=' + this.alumnoId + '&t='+ this.$store.getters.token.substring(7)" target="_blank" style="font-size: 80%; margin-bottom: 10px;">
                    Toque aquí para ver la información
                  </a>

                  <!-- Estrellas y puntuación numérica debajo del enlace -->
                  <div class="row ml-0 align-items-center" style="margin-top: -7px; margin-left: 20px;">
                    <!-- Componente star-rating para mostrar las estrellas -->
                    <star-rating 
                      v-model="this.puntaje" 
                      :increment="0.01" 
                      :max-rating="5" 
                      inactive-color="#f1f1f1"
                      active-color="#FFD700" 
                      :star-size="15"  
                      :read-only="true" 
                      :show-rating="false">
                    </star-rating>

                    <!-- Mostrar el puntaje numérico al lado de las estrellas -->
                    <div class="ml-3"> <!-- Aumentar el margen izquierdo -->
                      <p class="mb-0" style="line-height: 1.5;">{{ this.puntaje.toFixed(1) }}</p>
                    </div>
                  </div>
                </div>




                <div class="ml-auto" v-if="this.selectedOption == 1">
                  <v-select
                    v-model="selectedOperador"
                    :items="operadoresDisponibles"
                    item-text="nombre"
                    item-value="id"
                    label="Reasignar conversación a"
                    persistent-hint
                    return-object
                    single-line
                    class="align-self-end"
                    style="min-width: 200px;"
                    @change="dialogReasignar = true"
                  ></v-select>
                </div>
                <div @click="onDisconect" class="ml-auto" style="border-radius: 20px; display: flex; background-color: rgb(219, 29, 74); margin-left: 10vw; align-items: center; padding: 0.8vw 1vw; justify-content: center; cursor: pointer;" v-if="selectedOption == 1">
                  <p style="display: inline; text-align: center; margin: 0; color: white; font-weight: bold;">Finalizar</p>
                </div>
              </v-col>
              
              <v-col ref="allChatSelected" style="max-height: 52vh; background-color: #fbfafb;" class="overflow-y-auto" cols="12" @scroll="handleScroll()">
                <v-dialog v-model="showMotivoModal" max-width="500px">
                  <v-card>
                    <v-card-title>Se te ha derivado este Chat</v-card-title>
                    <v-card-text>
                      <v-subtitle-1>
                        <strong>Información aportada por el anterior operador:</strong>
                      </v-subtitle-1>
                      {{ this.motivo }}
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" @click="showMotivoModal = false">Cerrar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <div v-for="(msg, index) in allChatSelected" :key="index">

                  <p style="text-align: center">
                    <template v-if="msg.motivo">
                      <v-chip class="ma-2" small>
                        <strong>Motivo de reasignación:&nbsp;</strong>{{ msg.motivo }}
                      </v-chip>
                      <v-card color="transparent" class="mb-6" flat tile>
                        <small class="mt-2" style="font-size: 0.6rem; color: grey">
                          {{ msg.created_at.substr(11, 5) }}
                        </small>
                      </v-card>
                    </template>
                  </p>


                  <p>
                    
                   
                    <v-card
                      color="transparent"
                      class="d-flex justify"
                      flat
                      tile
                      v-if="(msg.user_message || msg.file) && msg.operator_name == null"

                    >
                      <a
                        style="text-decoration: none"
                        :href="msg.file"
                        :download="msg.filename"
                        target="_blank"
                        v-if="msg.file"
                      >
                        <v-sheet
                          color="white"
                          elevation="1"
                          width="100"
                          class="m-10 p-5 preview"
                          rounded
                          style="
                            text-align: center;
                            display: block;
                            margin: 10px 0;
                          "
                        >
                          <v-img
                            :src="msg.file"
                            width="100"
                            v-if="msg.type == 'image'"
                          ></v-img>
                          <v-icon
                            class="mt-5"
                            size="50"
                            color="#FFDB58"
                            v-if="msg.type && msg.type.match('image.*')"
                          >mdi-file-image</v-icon>

                          <v-icon
                            class="mt-5"
                            size="50"
                            color="red"
                            v-if="msg.type && msg.type.match('pdf.*')"
                          >mdi-file-pdf-box</v-icon>
                          <v-icon
                            class="mt-5"
                            size="50"
                            color="green"
                            v-if="msg.type && msg.type.match('excel.*')"
                          >mdi-file-excel</v-icon>
                          <v-icon
                            class="mt-5"
                            size="50"
                            color="blue"
                            v-if="msg.type && msg.type.match('word.*')"
                          >mdi-file-word</v-icon>
                          <v-icon
                            class="mt-5"
                            size="50"
                            color="orange"
                            v-if="msg.type && msg.type.match('presentation.*')"
                          >mdi-file-powerpoint</v-icon>
                          <v-icon
                            class="mt-5"
                            size="50"
                            color="purple"
                            v-if="msg.type && msg.type.match('video.*')"
                          >mdi-file-video</v-icon>
                          <v-icon
                            class="mt-5"
                            size="50"
                            color="darken"
                            v-if="
                              !msg.type ||
                              ( !msg.type.match('pdf.*') &&
                                !msg.type.match('image.*') &&
                                !msg.type.match('excel.*') &&
                                !msg.type.match('word.*') &&
                                !msg.type.match('presentation.*') &&
                                !msg.type.match('video.*'))
                            "
                          >mdi-file</v-icon>
                          <div style="display: flex; flex-direction: column; align-items: center; margin-top: 5px; max-width: 120px;">
                            <p style="margin-top: 5px; overflow: hidden; text-overflow: ellipsis; max-width: 90px;">{{ msg.filename }}</p>
                          </div>



                        </v-sheet>
                      </a>
                    </v-card>
                 



                    <v-card
                      color="transparent"
                      class="d-flex justify-start"
                      flat
                      tile
                    >
                      <v-card
                        color="white"
                        style="border-radius: 10px 10px 0px;"
                        :elevation="1"
                        class="pa-2 mr-1"
                        v-if="
                          msg.user_message
                        "
                        v-html="msg.user_message "
                      >
                      </v-card>
                    </v-card>

                      <v-card
                        color="transparent"
                        class="d-flex justify-start mb-6 mr-1"
                        flat
                        tile

                          v-if="(msg.user_message || msg.file) && msg.operator_name == null"
                        
                      >
                        <small
                          class="mt-2"
                          style="font-size: 0.6rem; color: grey"
                          >{{ msg.hora + ' - ' + nombreAlumno}}
                        </small>
                      </v-card>
                    </p>
                    <p>
                      <v-card
  color="transparent"
  class="d-flex justify-end"
  flat
  tile
  v-if="(msg.chatgpt_response || msg.file) && msg.operator_name !== null"
>
  <a
    style="text-decoration: none"
    :href="msg.file"
    :download="msg.filename"
    target="_blank"
    v-if="msg.file" 
  >
    <v-sheet
      color="#d5ecf5"
      elevation="1"
      width="100"
      class="m-10 p-5 preview"
      rounded
      style="
        text-align: center;
        display: block;
        margin: 10px 0;
      "
    >
      <v-img
        :src="msg.file"
        width="100"
        v-if="msg.type == 'image' && msg.file"
      ></v-img>
      <v-icon
        class="mt-5"
        size="50"
        color="#FFDB58"
        v-if="msg.type && msg.type.match('image.*') && msg.file"
      >mdi-file-image</v-icon>

      <v-icon
        class="mt-5"
        size="50"
        color="red"
        v-if="msg.type && msg.type.match('pdf.*') && msg.file"
      >mdi-file-pdf-box</v-icon>
      <v-icon
        class="mt-5"
        size="50"
        color="green"
        v-if="msg.type && msg.type.match('excel.*') && msg.file"
      >mdi-file-excel</v-icon>
      <v-icon
        class="mt-5"
        size="50"
        color="blue"
        v-if="msg.type && msg.type.match('word.*') && msg.file"
      >mdi-file-word</v-icon>
      <v-icon
        class="mt-5"
        size="50"
        color="orange"
        v-if="msg.type && msg.type.match('presentation.*') && msg.file"
      >mdi-file-powerpoint</v-icon>
      <v-icon
        class="mt-5"
        size="50"
        color="purple"
        v-if="msg.type && msg.type.match('video.*') && msg.file"
      >mdi-file-video</v-icon>
      <v-icon
        class="mt-5"
        size="50"
        color="darken"
        v-if="
          !msg.type ||
          ( !msg.type.match('pdf.*') &&
            !msg.type.match('image.*') &&
            !msg.type.match('excel.*') &&
            !msg.type.match('word.*') &&
            !msg.type.match('presentation.*') &&
            !msg.type.match('video.*')) &&
          msg.file
        "
      >mdi-file</v-icon>
      <div style="display: flex; flex-direction: column; align-items: center; margin-top: 5px; max-width: 120px;">
        <p style="margin-top: 5px; overflow: hidden; text-overflow: ellipsis; max-width: 90px;">{{ msg.filename }}</p>
      </div>
    </v-sheet>
  </a>
</v-card>

                      <v-card
                      color="transparent"
                      class="d-flex justify-end"
                      flat
                      tile
                    >
                      <v-card
                        color="#d5ecf5"
                        :elevation="1"
                        text-color="#616161"
                        class="pa-2 mb-2"
                        style="border-radius: 10px 10px 10px 0px"
                        v-if="
                          msg.chatgpt_response

                        "
                        v-html="msg.chatgpt_response"
                      >
                    </v-card>
                  </v-card>
                  <v-card
                  color="transparent"
                  class="d-flex justify-end ml-3"
                  
                  flat
                  tile
                  v-if="
                          (msg.chatgpt_response || msg.file) && msg.operator_name !== null
                        "
                    >
                      <small
                        style="font-size: 0.6rem; color: grey"
                      >
                        {{ msg.hora + ' - ' + msg.operator_name}} 
                      </small> 
                    </v-card>
                  </p>
                </div>
              </v-col>
            </v-card-text>
            <v-card-text style="padding: 0px 10px 0px 30px;">
              <!-- Aquí se puede incluir el componente o la lógica para el selector de emojis -->
              <div v-if="showEmojis" style="position: absolute; bottom: 50px; z-index: 1000;">
                <!-- Componente de selección de emojis -->
                <VEmojiPicker
                  class="elevation-1"
                  @select="selectEmoji"
                  emojiSize="25"
                  emojisByRow="9"
                />
              </div>
              
              <v-text-field
                v-model.trim="messageForm.content"
                :label="sendingMessage ? 'Enviando mensaje...' : 'Escribe un mensaje'"
                type="text"
                no-details
                :disabled="sendingMessage"
                outlined
                prepend-icon="mdi-emoticon"
                :append-outer-icon="messageForm.content ? 'mdi-send' : 'mdi-attachment'"
                @keyup.enter="addMessage(messageForm.content, chatId)"
                @click:append-outer="messageForm.content ? addMessage(messageForm.content, chatId) : attachFile();"
                @click:prepend="showEmojis = !showEmojis"
                @click="showEmojis = false"
                @focus="showEmojis = false"
                hide-details
                clear-icon="mdi-close-circle"
                clearable
              />
            </v-card-text>

            <template>
              <v-dialog v-model="showImageAttach" max-width="825" scrollable>
                <v-card>
                  <v-card-title
                    class="text-h5 justify-center modal-info"
                    style="color: white"
                  >
                    Adjuntar archivo
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="hiddeAttachDialog()">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title>

                  <v-card-text>
                    <v-alert outlined dense type="info" class="mt-2">
                      <small
                        >Tamaño máximo por archivo
                        <strong>{{ max_size_file }}MB</strong></small
                      >
                    </v-alert>
                    <p>
                      <v-row class="mt-2">
                        <div
                          v-for="(file, index) in messageForm.files"
                          :key="index"
                          style="text-align: center"
                        >
                          <v-chip
                            class="ma-4"
                            close
                            color="#f2f2f2"
                            close-icon="mdi-delete"
                            text-color="blue"
                            @click:close="deleteFileChatThumnail(index)"
                          >
                            <v-sheet
                              color="white"
                              elevation="1"
                              height="100"
                              width="100"
                              class="m-10 p-5 preview"
                            >
                              <div style="text-align: center">
                                <img
                                  :src="file.url"
                                  v-if="file.type.match('image.*')"
                                />
                                <v-icon
                                  class="mt-5"
                                  size="50"
                                  color="red"
                                  v-if="file.type.match('pdf.*')"
                                  >mdi-file-pdf-box</v-icon
                                >
                                <v-icon
                                  class="mt-5"
                                  size="50"
                                  color="green"
                                  v-if="file.type.match('excel.*')"
                                  >mdi-file-excel</v-icon
                                >
                                <v-icon
                                  class="mt-5"
                                  size="50"
                                  color="blue"
                                  v-if="file.type.match('word.*')"
                                  >mdi-file-word</v-icon
                                >
                                <v-icon
                                  class="mt-5"
                                  size="50"
                                  color="orange"
                                  v-if="file.type.match('presentation.*')"
                                  >mdi-file-powerpoint</v-icon
                                >
                                <v-icon
                                  class="mt-5"
                                  size="50"
                                  color="purple"
                                  v-if="file.type.match('video.*')"
                                  >mdi-file-video</v-icon
                                >
                              </div>
                            </v-sheet>
                          </v-chip>
                          <p>
                            <small :title="file.name"
                              >{{
                                file.name.length > 30
                                  ? file.name.substr(0, 20) + "..."
                                  : file.name
                              }}
                            </small>
                          </p>
                        </div>
                      </v-row>
                      <v-text-field
                        v-model.trim="messageForm.content"
                        label="Escribe un mensaje"
                        type="text"
                        no-details
                        densed
                        append-outer-icon="mdi-send"
                        @keyup.enter="addMessage(messageForm.content,chatId)"
                        @click:append-outer="addMessage(messageForm.content,chatId)"
                        hide-details
                      />
                    </p>

                    <div class="box-container justify-center">
                      <span class="box color1-logo"></span>
                      <span class="box color2-logo"></span>
                      <span class="box color3-logo"></span>
                      <span class="box color4-logo"></span>
                      <span class="box color5-logo"></span>
                    </div>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="justify-space-around">
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="hiddeAttachDialog()"
                      small
                    >
                      Cancelar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <input
                id="file-upload"
                type="file"
                v-on:change="addImageGroup()"
                ref="fileInputGroup"
                style="visibility: hidden"
              />
              <input
                id="file-upload"
                type="file"
                v-on:change="onFilesChange"
                ref="filesChat"
                style="visibility: hidden"
                multiple=""
              />
            </template>
          </v-row>
          <v-row v-else>
            <v-col>
              <h2>Selecciona un chat</h2>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-dialog v-model="dialogReasignar" max-width="400px">
        <v-card>
          <v-card-title>Reasignar operador</v-card-title>
          <v-card-text>
            ¿Está seguro de reasignar el chat a este operador?
            <v-text-field 
              v-model="reasignarMotivo" 
              label="Motivo de la reasignación" 
              required
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn 
              color="primary" 
              small 
              @click="reasignarChatOperador(selectedOperador.id)" 
              :disabled="!reasignarMotivo"
            >Aceptar</v-btn>
            <v-btn color="grey darken-1" small dark @click="cancelActionReasignar">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


    </CardIeaAppMain>
  </div>
</template>

<script>
  import CardIeaAppMain from "../../components/CardIeaAppMain";
  import SocketConnection from "itoeste-socket";
  import { DEBUG, API_SOCKET } from "../../../env";
  import { VEmojiPicker } from "v-emoji-picker";
  import StarRating from 'vue-star-rating'; 

  export default {
    components: {
      CardIeaAppMain,
      VEmojiPicker,
      StarRating,

    },

    data() {
      return {
        isOn: false,
        isButtonActive: false,
        buttonColor2: 'rgb(8, 93, 161)', // Default button color
        interception: false,
        inactiveChats: [], // Cola para almacenar los chats inactivos
        currentInactiveChat: null, // Chat actualmente siendo procesado
        showInactiveModal: false,
        motivo: '',
        openedChats: {},
        showMotivoModal: false,
        currentPage: null, // Start with null to load the last page initially
        lastPage: null,
        loading: false,
        debug: DEBUG,
        showEmojis: false,
        buttonColor: 'green',
        isButtonPressed: false,
        nombreAlumno: undefined,
        autoMessageCounters: {}, 
        //autoMessageCounter: 0,
        chatFocused: undefined,
        textSearch: "",
        messageForm: {
          content: "",
          files: [],
        },
        limit: 10,
        showImageAttach: false,
        max_size_file: 30,
        sendingMessage: false,
        showMenu: true,
        showChatPanel: true,
        chats: [],
        selectedChat:null,
        reasignarMotivo: '',
        chatId: null,
        allChatSelected: [],
        operadores: [],
        companeros: [],
        selectedOption: null,
        countTu: 0,
        countOtros: 0,
        countTodo: 0,
        selectedOperador: null,
        dialogReasignar: false,
        operadorEncontrado: null,
        textSearchContact:  null,
        operadorAlumnoTu: undefined,
        operadorAlumnoOtros: undefined,
        operadorAlumnoTodo: undefined,
        ws: SocketConnection(
          {
            debug: DEBUG,
            token: API_SOCKET,
          },
          () => {}
          ),
      };
    },
     mounted() {
       this.getChatsAlumno();
       this.getOperadores();
       console.log('Operador alumno tu ')
      this.ws.subscribeChannel('operator-chats-all', (e) =>{
        switch (e.action) {
          case "change-chats": 
            this.getChatsAlumno();
            this.getOperadores();
            break;
        }
       } );
      
       this.ws.subscribeChannel('operator-chats-' + this.$store.getters.user.IDStB , (e) => {
          switch (e.action) {
              case "asignar-operador":
                  console.log('jelou madafacas como tan')
                  this.playSound();
                  this.showOperatorAssignmentNotification();
                  break;
              case "new-messages":
                  break;
              case 'disconnected-operator':
                  break;
              case 'litle-time-change-operator':
                  this.playSound();
                  break;
          }
          this.getChatsAlumno();
      });


       console.log('-------->')
      let url = 'op/materiaPlanEstudio/v2/materiasOptativas/11103?draw=1&columns%5B0%5D%5Bdata%5D=id&columns%5B0%5D%5Bname%5D=id&columns%5B0%5D%5Bsearchable%5D=true&columns%5B0%5D%5Borderable%5D=true&columns%5B0%5D%5Bsearch%5D%5Bvalue%5D=&columns%5B0%5D%5Bsearch%5D%5Bregex%5D=false&columns%5B1%5D%5Bdata%5D=materia&columns%5B1%5D%5Bname%5D=materia&columns%5B1%5D%5Bsearchable%5D=true&columns%5B1%5D%5Borderable%5D=true&columns%5B1%5D%5Bsearch%5D%5Bvalue%5D=&columns%5B1%5D%5Bsearch%5D%5Bregex%5D=false&columns%5B2%5D%5Bdata%5D=materia_asignada&columns%5B2%5D%5Bname%5D=materia_asignada&columns%5B2%5D%5Bsearchable%5D=true&columns%5B2%5D%5Borderable%5D=true&columns%5B2%5D%5Bsearch%5D%5Bvalue%5D=&columns%5B2%5D%5Bsearch%5D%5Bregex%5D=false&order%5B0%5D%5Bcolumn%5D=0&order%5B0%5D%5Bdir%5D=asc&start=0&length=10&search%5Bvalue%5D=&search%5Bregex%5D=false&_=1709646118076';
      this.$API
      .get({
        url:url
      },false)
      .then((res)=>{
        console.log('------>', res)
      }).catch((err)=>{
        console.log('<-----------',err)
      })

    },
    computed: {
      selectedChatData() {
        // obtener conversacion de chat
        let chatList = this.getSelectedOptionChats();
        
        return this.selectedChat ? chatList.find(chat => chat.chatGptId === this.selectedChat) : null;
      },

      
    },
    methods: {
      toggleButton(selectedChat) {
        this.isOn = !this.isOn;
        this.interception = this.isOn;
        console.log('Este es el alumno aydiiiihihiiiii->', this.alumnoId)
        console.log('este es el this.selected --->', selectedChat)
        // Crea el objeto formData con los datos que quieres enviar
        const formData = {
          interception: this.isOn,
          alumnoId: this.alumnoId,
          selectedChat:selectedChat
        };

        // Realiza la solicitud POST utilizando tu método $API.post
        this.$API.post(
          {
            url: "operadores/interception/" + this.alumnoId, // URL dinámica con el ID del chat
            data: formData
          },
          false // Supongo que este parámetro podría ser para algo como mostrar un mensaje o manejar un loading
        );

        this.isButtonActive = true;
        this.buttonColor2 = 'rgb(18, 120, 220)'; // Lighter color for press effect

        // Remove the press effect after the animation ends
        setTimeout(() => {
          this.isButtonActive = false;
          this.buttonColor2 = 'rgb(8, 93, 161)'; // Reset to original color
        }, 1000); // 
      },

      isInactive(horaUltimoMensaje, fechaUltimoMensaje) {
        const currentDate = new Date();
        const [hours, minutes] = horaUltimoMensaje.split(':');
        const lastMessageDate = new Date(fechaUltimoMensaje);
        lastMessageDate.setHours(hours);
        lastMessageDate.setMinutes(minutes);

        // Verifica si el mensaje es del mismo día
        const isSameDay = currentDate.toDateString() === lastMessageDate.toDateString();

        // Verifica si ha pasado más de una hora desde el último mensaje
        const timeDifference = currentDate - lastMessageDate;
        const oneHour = 60 * 60 * 1000;


        // Retorna true si ha pasado más de una hora y es del mismo día, o si es de un día anterior
        return (isSameDay && timeDifference > oneHour) || !isSameDay;
      },


      showOperatorAssignmentNotification() {
        // Aquí puedes usar un componente de notificación, una alerta o cualquier otro indicador visual.
        this.$notify({
            group: 'operator',
            title: 'Chat asignado',
            text: 'Se ha asignado un nuevo chat.',
            type: 'success'
        });
    },

      selectEmoji(emoji) {
        this.messageForm.content += emoji.data;
      },
      pressButton() {
        this.isButtonPressed = true;
      },
      releaseButton() {
        this.isButtonPressed = false;
      },

      darkenIcon() {
        document.getElementById('powerButton').style.borderColor = 'rgba(0, 0, 0, 0.5)';
      },
      lightenIcon() {
        document.getElementById('powerButton').style.borderColor = 'transparent';
      },

      toggleColor() {
        this.buttonColor = this.buttonColor === 'green' ? 'red' : 'green';
        return this.buttonColor;
      },
      
      async operatorStatus(){
        const colorOption = this.toggleColor();
        
        await this.$API.post({ url: "operator-status", data: {
          id: this.$store.getters.user.IDStB, 
          disabled: colorOption=='green' ? false : true
        }}, false)
        .then(res => console.log('exitoso : --------', res));
      },
      
      
      getType_(file) {
        let alloweds = [
          { t: "pdf", c: "red" },
          { t: "word", c: "blue" },
          { t: "image", c: null },
          { t: "video", c: "purple" },
          { t: "excel", c: "green" },
          { t: "presentation", c: "orange" },
        ];
        let type = null;
        alloweds.forEach((allowed) => {
          if (file.type.match(allowed.t + ".*")) {
            type = allowed;
          }
        });
        return type;
      },

      getType(file) {
        let alloweds = ["pdf", "word", "image", "video", "excel", "presentation"];
        let type = "";
        alloweds.forEach((mime) => {
          if (file.type.match(mime + ".*")) {
            type = mime;
          }
        });
        return type;
      },  

      addImageGroup() {
        let val = this.$refs.fileInputGroup.files[0];
        if (val.type.match("image.*")) {
          val.url = URL.createObjectURL(val);
          this.chatActive.image = val.url;
        }
      },

      deleteFileChatThumnail(index) {
        this.messageForm.files.splice(index, 1);
      },

      hiddeAttachDialog() {
        this.showImageAttach = false;
        this.messageForm.files = [];
      },

      isAllowed(file) {
        let alloweds = ["pdf", "word", "image", "video", "excel", "presentation"];
        let allowed = false;
        alloweds.forEach((mime) => {
          if (file.type.match(mime + ".*")) {
            allowed = true;
          }
        });
        return allowed;
      },

      hasAllowedSize(file) {
        let allowed = false;
        let limit = this.max_size_file * 1024 * 1024;
        if (file.size <= limit) {
          allowed = true;
        }
        return allowed;
      },

      async attachFile() {
        this.$refs.filesChat.click();
      },

      onFilesChange(e) {
        
        let all = [...e.target.files];
        
        if (all.length > 0) {
          all.forEach((val) => {
            if (this.messageForm.files.length < this.limit) {
              if(val.type.match('image.*')|| val.type.match('pdf.*') || val.type.match('word.*') || val.type.match('video.*')|| val.type.match('excel.*')|| val.type.match('presentation.*')){
              val.url = URL.createObjectURL(val);
                if (this.isAllowed(val) && this.hasAllowedSize(val)) {
                  this.messageForm.files.push(val);
                  console.log('ARCHIVOOOOOOOO',this.messageForm.files)
              }}
            }
          });
          if (this.messageForm.files.length > 0) {
            this.showImageAttach = true;
          } else {
            this.showAlert = true;
            this.contentAlert = "Imposible enviar esos archivos";
            this.typeAlert = "modal-danger";
          }
        }

      },

      playSound() { 
        const audio = new Audio( require("@/assets/notification.mp3") );
        audio.play();
      },

      onReceiveMessage(data) {
        if (this.$store.getters.user.id != data.user_id) {
          this.playSound();
        }
        if(this.chatFocused && this.selectedChat) {
          let url = "operadores/messages/responsive/" + this.selectedChat;
          this.$API
          .get({
            url: url
          },
          false
        ).then((res) => {
          //Inactividad revisar
          console.log('CAMPOS Y COSAS QUE TRAE EL OPERADOR',res.response)
          console.log('ESTO ES EL ENDPOINT CON THIS.SELECTEDCHAT-->', this.selectedChat)
            this.allChatSelected = res.response;
            this.currentPage = res.currentPage - 1;
            this.scroll() });
        }
  
      },
      onDeleteMessage(data) {
        console.log(data)
      },

      onDisconect() {
        this.$API.post({ url: "chatgpt/liberar-operador", data: {id: this.alumnoId} }, false)
          .then(res => console.log('exitoso : --------', res));
      },
      async sendMessage(chatId, message, autoMessage) {
        console.log('El mensaje es: ', message);
        this.sendingMessage = true;
        
        // Asegúrate de que message siempre tenga un valor, incluso si es una cadena vacía
        message = message || '';

        if (this.messageForm.files.length > 0 || message) { // Verifica si hay archivos o un mensaje
          var formData = new FormData();

          if (this.messageForm.files.length > 0) {
            this.messageForm.files.forEach(file => {
              formData.append("file", file);
              formData.append("type", this.getType(file));
            });
          }
          
          // Añade el mensaje al FormData (incluso si es una cadena vacía)
          formData.append("userMessage", message);

          this.$API.post(
            {
              url: "operadores/messages/" + this.selectedChat,
              data: formData
            },
            false
          )
          .then(() => {
            console.log('no se si es exitoso o nooooooooooooooooooooooooo');
            //this.ws.sendMessage(res)
            //this.ws.chatAction('message-new', res)
            this.messageForm.content = "";
            this.tab = 0;
            this.sendingMessage = false;
            this.messageForm.files = [];
            this.messageResend = null;
            console.log(autoMessage)
          });
        }
        
        this.getChatsAlumno();
        this.showImageAttach = false;
      },
   

addMessage(content, chatActiveId, autoMessage) {   
  console.log('Esto es en addmessage y los datos respectivos content y chatActiveId', content, chatActiveId);  
  
  // Llama a sendMessage incluso si el contenido está vacío, siempre y cuando chatActiveId esté presente
  if (chatActiveId) {
    this.sendMessage(chatActiveId, content || '', autoMessage); // Asegúrate de pasar una cadena vacía si `content` es falsy
  }
},



getSelectedOptionChats() {
  switch (this.selectedOption) {
    case 1:
      return this.operadorAlumnoTu;
    case 2:
      return this.operadorAlumnoOtros;
    case 3:
      return this.operadorAlumnoTodo;
    case 4:
      return this.chatsCompanero;
    case 5:
      return this.todosRegistros;
  }
},
      getChatsAlumno() {
        let url = "operadores/index-alumnos";
        this.$API
          .get({
            url: url
          },
          false
          ).then((res) => {
            this.operadorAlumnoTodo = res.operadorAlumnoTodo;
            this.operadorAlumnoTu = res.operadorAlumnoTu;
            this.todosRegistros = res.todosRegistros;
            this.countTodosRegistros = res.TotalRegistrosTodos
            this.buttonColor = res.Disponible == 1 ? 'green' : 'red';
            this.tiempoInac = res.Tiempo_de_inactividad;
            this.operadorAlumnoOtros = res.operadorAlumnoOtros;
            this.countTodo = res.TotalAsignacionesTodo;
            this.countTu = res.TotalAsignacionesTu; 
            this.countOtros = res.TotalAsignacionesOtros;
          });
      },




      processNextInactiveChat() {
        if (this.inactiveChats.length > 0) {
          this.currentInactiveChat = this.inactiveChats.shift();
          this.showInactiveModal = true;
        } else {
          this.currentInactiveChat = null;
        }
      },
      handleYes() {
        if (this.currentInactiveChat) {
          console.log(`Finalizando la conversación con el chat ID: ${this.currentInactiveChat}`);
          this.alumnoId = this.currentInactiveChat;
          this.onDisconect(this.alumnoId);
          this.showInactiveModal = false;
          this.processNextInactiveChat();
        }
      },
      handleNo() {
        this.showInactiveModal = false;
        this.processNextInactiveChat();
      },

      selectMenuItem(option) {
        this.selectedOption = option;
      },
      toggleChatPanel() {
        this.showChatPanel = !this.showChatPanel;
      },
      getSelectedChat(chat, ifView) {
        console.log('ifView a ver que trae --->', ifView)
    this.selectedChat = chat?.chatGptId;
    this.chatId = chat?.chatGptId;
    this.alumnoId = chat?.alumnoId;
    this.allChatSelected = [];
    this.currentPage = null; // Start with null to load the last page initially
    this.lastPage = null;
    this.loading = false;

    // Load messages
    this.loadMessages().then(() => {
        // Recuperar el estado de los chats abiertos y sus motivos desde localStorage
        const openedChats = JSON.parse(localStorage.getItem('openedChats')) || {};

        // Comparar el motivo actual con el guardado en localStorage
        if (this.motivo && openedChats[chat.chatGptId] !== this.motivo) {
            console.log('Motivo actualizado: ', this.motivo);
            this.showMotivoModal = true;
            // Guardar el nuevo motivo en localStorage
            openedChats[chat.chatGptId] = this.motivo;
            localStorage.setItem('openedChats', JSON.stringify(openedChats));
        }
    });

    if (ifView) {
        console.log('Entra en el ifView ---->',chat?.chatGptId)
        this.$API.post({ url: "operadores/view-message/" + chat?.chatGptId }, false);
        this.getChatsAlumno();
    }
    console.log('ESTO ES EL ENDPOINT CON CHAT?.CHATGPTID-->', chat?.chatGptId);

    // Delay the subscription to the channel
    setTimeout(() => {
        this.ws.subscribeChannel("chat-operador-" + this.alumnoId, (result) => {
            console.log("Recibiendo evento por socket CHAT OPERADOR", this.alumnoId);
            console.log(result);
            switch (result.action) {
                case "message-new":
                    this.onReceiveMessage(JSON.parse(result.message));
                    this.getChatsAlumno();
                    break;
                case "message-delete":
                    this.onDeleteMessage(result);
                    break;
                case "close-mode-operator":
                    this.getChatsAlumno();
                    this.getOperadores();
                    this.selectedOption = null;
                    break;
            }
        });
    }, 500); // Delay of 500ms or adjust as needed

    if (chat.operator_response === 0 && (chat.operador_id == this.$store.getters.user.IDStB)) {
        this.addMessage(`Hola, un gusto. Te saluda ${this.$store.getters.user.Nombres}`, chat.chatGptId, true);
    }

    setTimeout(() => {
        this.scroll();
    }, 1000);
},


loadMessages(page = this.currentPage) {
    return new Promise((resolve, reject) => {
        if (page == null || page == undefined) {
            this.fetchLastPage()
                .then(lastPage => {
                    console.log('Esto ------------------> se llama');
                    this.loadMessages(lastPage).then(resolve).catch(reject);
                })
                .catch(error => {
                    console.error('Error fetching last page:', error);
                    this.loading = false;
                    reject(error);
                });
            return;
        }

        if (this.loading || page < 1 || (this.currentPage && page > this.lastPage)) {
            resolve(); // Resolves immediately if conditions are not met
            return;
        }

        this.loading = true;
        let url = `operadores/messages/${this.chatId}?page=${page}`;

        this.$API.get({ url: url }, false)
            .then((res) => {
                if (res.response.length > 0) {
                    console.log('loadMEssages aaaaaaaaaaaaaaaaaaaaaaaaah')
                    this.allChatSelected = (res.response || []).concat(this.allChatSelected);
                    this.nombreAlumno = res.alumnoActual.Nombres;
                    this.puntaje = res.alumnoActual.puntaje;
                    this.currentPage = res.currentPage;
                    this.lastPage = res.lastPage;
                    this.motivo = res.motivo;
                    console.log('una rosa pintada de azul es un:     ', this.motivo);
                    this.loading = false;
                    if (this.currentPage >= 1) {
                        this.currentPage--;
                    }
                    resolve(); // Resolves the promise when messages are successfully loaded
                } else {
                    this.loading = false;
                    resolve(); // Resolves even if no new messages were loaded
                }
            })
            .catch(() => {
                this.loading = false;
                reject(); // Rejects if there's an error in loading messages
            });
    });
},

clearMotivoAfterDisplay() {
    this.motivo = null; // Clear the motivo to ensure the modal doesn't show again for this chat
},


fetchLastPage() {
  let url = `operadores/messages/${this.chatId}?page=1`;

  return this.$API.get({ url: url }, false)
    .then((res) => {
      return res.lastPage;
    })
    .catch(error => {
      console.error('Error fetching last page:', error);
      throw error;
    });
},

  handleScroll() {
    if (this.$refs.allChatSelected.scrollTop === 0) {
      if (this.currentPage && this.currentPage >= 1) {
        this.loadMessages(this.currentPage);
      }
    }
  },
      scroll() {
        this.$nextTick(() => {
          const allChatSelected = this.$refs.allChatSelected;
          allChatSelected.scrollTo({
            top: allChatSelected.scrollHeight,
            behavior: 'auto'
          });
        });
      },
      getOperadores() {
        let url = "operadores";
        this.$API
          .get({
            url: url
          }, false)
          .then((res) => {
            this.operadores = [{ id: 0, nombre: 'ChatGPT' }, ...res.response];
            this.companeros = res.response;
            this.operadoresDisponibles = res.response.filter(operador => operador.disponible === 1);
          })
          .catch((error) => {
            console.error('Error fetching operadores:', error);
          });
      },

      getChatsCompanero(companero_id) {
        this.selectMenuItem()

        let url = "operadores/chats-companero/" + companero_id;
         this.$API
        .get({
          url: url
        },
        false
        ).then((res) => {
          this.chatsCompanero = res.response; 
          this.selectMenuItem(4)
        });
      },
      reasignarChatOperador(nuevoOperadorId){

        let chatgptId = this.selectedChat;
        let motivo = this.reasignarMotivo;
        this.dialogReasignar = true;

        let url = "operadores/reasignar-operador/" + nuevoOperadorId;
        this.$API
        .post({
          url: url,
          data: {
            chatgptId,
            motivo
          }
        }).then(() => {
          this.dialogReasignar = false;
          this.selectedOperador = null;
          this.reasignarMotivo = '';
        })
      },
      cancelActionReasignar() {
        this.dialogReasignar = false;
        this.reasignarMotivo = '';
      },
      searchOperadores() {
        this.operadorEncontrado = null;
        let url = `operadores/search?search=${this.textSearchContact}`;
        
        this.$API
          .get({
            url: url, 
          },
          false
          ).then((res) => { 
            this.operadorEncontrado = res.response; 
          });
      },
    },
    watch: {
      selectedOption() {
        this.selectedChat = null;
        this.chatId = null;
        this.alumnoId = null;
      },
    },
  };
  //Ramon antonio gomez@istitutoeia.edu.ae usuario de Denis
</script>
